import { useTranslation } from "@/hooks/useTranslation/useTranslation"
import { Message as ChatMessage } from "@/types/assistantChat"
import React from "react"
import { MessageRenderer } from "./MessageRenderer"
import { extractUniqueCitations } from "./utils/chatUtils"

interface ChatMessageProps {
  message: ChatMessage
  index: number
}

export const ChatMessageItem: React.FC<ChatMessageProps> = ({
  message,
  index,
}) => {
  const { translate } = useTranslation()
  const role = message.role === "citation" ? "assistant" : message.role
  const uniqueCitations = extractUniqueCitations(
    message,
    role,
    translate("AI_CHAT/UNKNOWN_SOURCE"),
  )

  return (
    <div key={index}>
      <MessageRenderer
        role={role}
        content={message.content}
        blocks={message.blocks}
        reasoning={message.reasoning}
        reasoningDuration={message.reasoningDuration}
        citations={uniqueCitations}
        sourceMetadata={message.sourceMetadata}
      />
    </div>
  )
}
